// src/components/forms/SurveyListAudienceItem.js
import React from 'react';
import { UserCog, BarChart3, MessageSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';

// Expects surveyInfo (matching SurveyInfo Pydantic model) and refreshData function
function SurveyListAudienceItem({ surveyInfo, refreshData }) {
	const surveyTitleDisplay = surveyInfo?.title || 'Untitled Survey';
	const navigate = useNavigate();

	const handleAudienceConfigClick = () => {
		console.log(`Navigating to audience config for survey with ID: ${surveyInfo.survey_id}`);
		navigate(`/dashboard/audience/${surveyInfo.survey_id}`);
	};

	const handleResponseClick = () => {
		console.log(`Navigating to responses for survey with ID: ${surveyInfo.survey_id}`);
		navigate(`/dashboard/responses/${surveyInfo.survey_id}`);
	};

	const handleAnalyticsClick = () => {
		console.log(`Navigating to analytics for survey with ID: ${surveyInfo.survey_id}`);
		alert(`Analytics Not implemented yet`);
	};

	// Mock data for survey stats - replace with actual API data later
	const mockStats = {
		generatedLinks: 127,
		outdatedLinks: 12,
		revokedLinks: 3,
		validatedSurveys: 89
	};

	return (
		<div className='border shadow-sm rounded-lg p-6 flex flex-col h-full relative min-h-[280px]'>
			<div className='flex justify-between items-center'>
				<h2 className='text-lg font-semibold text-black flex-grow truncate'>{surveyTitleDisplay}</h2>
				<div className="flex items-center gap-1">
					<span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full">Active</span>
				</div>
			</div>

			<h3 className='text-sm text-gray-500 mt-1 mb-4'>
				ID: {surveyInfo.survey_id} - Created: {new Date(surveyInfo.created_at).toLocaleDateString()}
			</h3>

			<hr className='my-2'></hr>

			{/* Survey Statistics */}
			<div className='flex-grow my-4'>
				<h4 className='text-md font-medium text-gray-700 mb-3'>Audience Statistics</h4>
				<div className='grid grid-cols-2 gap-4'>
					<div className='bg-blue-50 p-3 rounded-lg'>
						<div className='text-2xl font-bold text-blue-600'>{mockStats.generatedLinks}</div>
						<div className='text-sm text-blue-800'>Generated Links</div>
					</div>
					<div className='bg-yellow-50 p-3 rounded-lg'>
						<div className='text-2xl font-bold text-yellow-600'>{mockStats.outdatedLinks}</div>
						<div className='text-sm text-yellow-800'>Outdated Links</div>
					</div>
					<div className='bg-red-50 p-3 rounded-lg'>
						<div className='text-2xl font-bold text-red-600'>{mockStats.revokedLinks}</div>
						<div className='text-sm text-red-800'>Revoked Links</div>
					</div>
					<div className='bg-green-50 p-3 rounded-lg'>
						<div className='text-2xl font-bold text-green-600'>{mockStats.validatedSurveys}</div>
						<div className='text-sm text-green-800'>Validated Surveys</div>
					</div>
				</div>
			</div>

			<hr className='my-2'></hr>

			{/* Action Buttons - All visible without dropdown */}
			<div className='flex justify-between items-center mt-auto gap-2'>
				{/* Primary Action - Audience Config */}
				<Button
					onClick={handleAudienceConfigClick}
					variant="primary"
					className="flex gap-2 items-center px-3 py-2 border rounded text-sm text-gray-700 hover:bg-gray-100 transition-colors"
				>
					<UserCog className='h-10 w-4'/> Audience
				</Button>

				{/* Secondary Actions */}
				<Button
					onClick={handleResponseClick}
					variant="secondary"
					className="flex gap-2 items-center px-3 py-2 border rounded text-sm text-gray-700 hover:bg-gray-100 transition-colors"
				>
					<MessageSquare className='h-10 w-4'/> Responses
				</Button>

				<Button
					onClick={handleAnalyticsClick}
					variant="secondary"
					className="flex gap-2 items-center px-3 py-2 border rounded text-sm text-gray-700 hover:bg-gray-100 transition-colors"
				>
					<BarChart3 className='h-10 w-4'/> Analytics
				</Button>
			</div>
		</div>
	);
}

export default SurveyListAudienceItem;